import D2C_TariffExtraMembers from './ExtraMembers'

class D2C_TariffExtraMembersAnnual extends D2C_TariffExtraMembers {
  isAnnual = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5b7176c8bf716b010c221804'
  static tariffTitle = 'Extra members annual'
}

export default D2C_TariffExtraMembersAnnual
